"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SelectSearch = _interopRequireDefault(require("../SelectSearch"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _fixtures = require("./fixtures");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialValues = {
  day: '',
  month: '',
  year: ''
};
const DateSelect = _ref => {
  let {
    disabled = false,
    error = '',
    hasError = false,
    height = '40px',
    hideDays = false,
    locale = 'es',
    margin = '0px',
    menuPlacement = 'bottom',
    nextYears = 0,
    onChange = () => null,
    value
  } = _ref;
  const [currentDate, setCurrentDate] = (0, _react.useState)(_objectSpread({}, initialValues));
  const [dayOptions, setDayOptions] = (0, _react.useState)((0, _fixtures.days)(31));
  const [yearOptions, setYearOptions] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setYearOptions((0, _fixtures.years)(nextYears));
  }, [nextYears, setYearOptions]);
  (0, _react.useEffect)(() => {
    if (!value) {
      setCurrentDate(_objectSpread({}, initialValues));
    } else {
      setCurrentDate(value);
    }
  }, [setCurrentDate, value]);
  const {
    month,
    year
  } = currentDate;
  (0, _react.useEffect)(() => {
    if (!!month || !!year) {
      const newDate = (0, _dayjs.default)().month(month ? Number(month) - 1 : (0, _dayjs.default)().month()).year(year ? Number(year) : (0, _dayjs.default)().year());
      setDayOptions((0, _fixtures.days)(Number(newDate.endOf('month').format('D'))));
    }
  }, [month, year]);
  const handleChange = (id, value) => {
    const newDate = _objectSpread(_objectSpread({}, currentDate), {}, {
      [id]: value
    });
    if (id === 'month' || id === 'year') {
      const {
        day,
        month,
        year
      } = _objectSpread(_objectSpread({}, currentDate), {}, {
        [id]: value
      });
      const actualYear = year ? Number(year) : (0, _dayjs.default)().year();
      const actualMonth = month ? Number(month) - 1 : (0, _dayjs.default)().month();
      const actualDate = (0, _dayjs.default)().set('year', actualYear).set('month', actualMonth);
      const daysInMonth = actualDate.daysInMonth();
      if (day && day > daysInMonth) {
        newDate.day = daysInMonth.toString();
      }
    }
    setCurrentDate(newDate);
    onChange(newDate);
  };
  const displayLabel = {
    en: {
      day: 'Day',
      month: 'Month',
      year: 'Year'
    },
    es: {
      day: 'Día',
      month: 'Mes',
      year: 'Año'
    }
  };
  const commonProps = {
    align: 'center',
    disabled,
    fontSize: '13px',
    hasError: !!error || hasError,
    height,
    hideSelectedOptions: false,
    menuPlacement,
    searchStart: true,
    width: '100%'
  };
  const containerProps = {
    margin
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Row, {
      children: [!hideDays && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Col, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectSearch.default, _objectSpread(_objectSpread({}, commonProps), {}, {
          options: dayOptions,
          placeholder: displayLabel[locale]['day'],
          value: currentDate['day'],
          width: "100%",
          onChange: value => handleChange('day', value)
        }))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Col, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectSearch.default, _objectSpread(_objectSpread({}, commonProps), {}, {
          options: _fixtures.months,
          placeholder: displayLabel[locale]['month'],
          value: currentDate['month'],
          width: "100%",
          onChange: value => handleChange('month', value)
        }))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Col, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectSearch.default, _objectSpread(_objectSpread({}, commonProps), {}, {
          options: yearOptions,
          placeholder: displayLabel[locale]['year'],
          value: currentDate['year'],
          width: "100%",
          onChange: value => handleChange('year', value)
        }))
      })]
    }), !!error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Row, {
      margin: "5px 0px 0px 0px",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Col, {
        xs: "12",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.ErrorMessage, {
          children: error
        })
      })
    })]
  }));
};
DateSelect.propTypes = {
  disabled: _propTypes.default.bool,
  error: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  height: _propTypes.default.string,
  hideDays: _propTypes.default.bool,
  locale: _propTypes.default.string,
  margin: _propTypes.default.string,
  menuPlacement: _propTypes.default.oneOf(['auto', 'bottom', 'top']),
  nextYears: _propTypes.default.number,
  onChange: _propTypes.default.func,
  value: _propTypes.default.object
};
var _default = exports.default = DateSelect;